/* Use only Shopify's rendered chat controls; never erase browser storage or call private chat APIs. */
(() => {
 'use strict';
 function rootsOf(host){
  const roots=host?.shadowRoot?[host.shadowRoot]:[];
  for(let i=0;i<roots.length&&i<20;i++)roots[i].querySelectorAll('*').forEach(el=>{if(el.shadowRoot)roots.push(el.shadowRoot);});
  return roots;
 }
 function visible(button){return !button.disabled&&button.getClientRects().length>0&&getComputedStyle(button).visibility!=='hidden';}
 function controls(host){return rootsOf(host).flatMap(root=>[...root.querySelectorAll('button')]);}
 function command(buttons,label){return buttons.find(b=>b.getAttribute('aria-label')===label&&visible(b));}
 function guestConfirmation(buttons){return buttons.find(b=>b.textContent.trim()==='Continue without signing in'&&visible(b));}
 if(typeof window==='undefined'){module.exports={rootsOf,command,guestConfirmation};return;}
 let running=false;
 document.addEventListener('click',event=>{
  const trigger=event.target.closest?.('[data-gx-tip-chat]');if(!trigger)return;
  event.preventDefault();event.stopImmediatePropagation();
  if(running)return;
  const host=document.querySelector('shopify-chat');
  if(!host){location.assign(`${window.Shopify?.routes?.root||'/'}pages/contact`);return;}
  running=true;host.setAttribute('data-gx-new-conversation','');
  const tip=document.getElementById('gx-assistant-tip');if(tip)tip.hidden=true;
  let resetClicked=false,guestClicked=false,resetAt=0,attempts=0,timer;
  function finish(){clearTimeout(timer);host.removeAttribute('data-gx-new-conversation');running=false;}
  function step(){
   if(!host.isConnected||++attempts>60){finish();return;}
   const buttons=controls(host),activator=buttons.find(b=>b.matches('[part~="activator"]'));
   if(activator?.getAttribute('aria-expanded')!=='true'){if(activator&&!resetClicked)activator.click();timer=setTimeout(step,100);return;}
   // Start a new conversation only for this explicit invitation. The normal Chat button resumes.
   if(!resetClicked){
    const reset=command(buttons,'Create a new chat');
    if(reset){resetClicked=true;resetAt=performance.now();reset.click();}
    timer=setTimeout(step,100);return;
   }
   // Shopify may ask a guest to confirm starting again without signing in.
   const confirmation=guestConfirmation(buttons);
   if(confirmation&&!guestClicked){guestClicked=true;resetAt=performance.now();confirmation.click();timer=setTimeout(step,150);return;}
   const panel=rootsOf(host).flatMap(root=>[...root.querySelectorAll('[part~="dialog"]')])[0];
   if(panel?.classList.contains('panel--empty-state')&&performance.now()-resetAt>350){finish();return;}
   // Bounded fallback leaves Shopify's own controls accessible if its UI changes or loads slowly.
   if(performance.now()-resetAt>4500){finish();return;}
   timer=setTimeout(step,150);
  }
  step();
 },true);
})();
